/**
 * @file labels.js
 * @location src/data/labels.js
 * @role 표시용 라벨 + 정렬 우선순위 상수
 *
 * STATUS          상태 키 enum (todo/done/cancelled) — razor ㉓: in_progress/review 폐기
 * PRIORITY        우선순위 키 enum (urgent/normal/low)
 * STATUS_META     상태별 라벨 + CSS cls (done/todo/cancelled) — statusMeta 안전조회 / CSV 등 직접참조
 * STATUS_ORDER    정렬용 상태 숫자      (todo=0 이 가장 앞)
 * PRIORITY_META   우선순위 라벨 + 태그 cls + 정렬 order 단일 소스 (priorityMeta 안전조회)
 * PRIORITY_OPTIONS [value,label] 목록 — 우선순위 버튼 렌더용 (order 순)
 * WEEKDAY_LABELS  요일 라벨 (1=월 … 7=일) — recurrence / RepeatRuleFields 공용
 */
export const STATUS   = { TODO: 'todo', DONE: 'done', CANCELLED: 'cancelled' };
export const PRIORITY = { URGENT: 'urgent', NORMAL: 'normal', LOW: 'low' };

/**
 * 우선순위 메타 — 표시 라벨 · 태그 CSS 색(cls) · 정렬 순서(order) 단일 소스.
 */
export const PRIORITY_META = {
  urgent: { label: '긴급', cls: 'red',    order: 0 },
  normal: { label: '보통', cls: 'purple', order: 1 },
  low:    { label: '낮음', cls: 'gray',   order: 2 },
};

/** 안전 조회 — 미지/폐기 우선순위는 normal 폴백 (statusMeta 와 동일 패턴) */
export const priorityMeta = (p) => PRIORITY_META[p] ?? PRIORITY_META.normal;

/** [value, label] 목록 (order 순) — 우선순위 선택 버튼 렌더용 */
export const PRIORITY_OPTIONS = Object.entries(PRIORITY_META).map(([value, m]) => [value, m.label]);

/** 요일 라벨 — key=ISO 요일번호(1=월 … 7=일). 반복 루틴 요일 선택·표시 공용(주말 포함). */
export const WEEKDAY_LABELS = { 1: '월', 2: '화', 3: '수', 4: '목', 5: '금', 6: '토', 7: '일' };

export const STATUS_META = {
  done:        { label: '완료',   cls: 'green'     },
  todo:        { label: '미착수', cls: 'purple'    },
  cancelled:   { label: '중지',   cls: 'cancelled' },
};

/**
 * 안전 조회 — 미지/폐기 status(legacy `in_progress`/`review` 등 마이그 스킵 잔류분)는
 * `todo` 메타로 폴백. STATUS_META[status] 직접 접근 시 undefined.cls 렌더 크래시 방지.
 * @param {string} status
 */
export const statusMeta = (status) => STATUS_META[status] ?? STATUS_META.todo;

/**
 * 표시용 핸드셰이크 상태 — status + acknowledgedAt 파생 (status 값은 불변: todo/done/cancelled).
 * razor ㉓ 위반 아님: in_progress 재도입이 아니라 읽음(acknowledgedAt) 신호를 라벨로 드러내는 표시 전용.
 *   미확인(미열람·안 읽음) / 확인(열람·미완료·읽음) / 완료 / 중지
 * @param {string} status
 * @param {string} [acknowledgedAt]
 */
export const ackStatusMeta = (status, acknowledgedAt) => {
  if (status === STATUS.DONE) return STATUS_META.done;
  if (status === STATUS.CANCELLED) return STATUS_META.cancelled;
  if (acknowledgedAt) return { label: '확인', cls: 'blue' };
  return { label: '미확인', cls: 'purple' };
};

export const STATUS_ORDER    = { todo: 0, done: 1, cancelled: 2 };

/** 종결(닫힘) 상태 — 완료 또는 중지. 활성 리스트·집계에서 제외 기준. */
export const isClosed = (status) => status === STATUS.DONE || status === STATUS.CANCELLED;


